import { GetterTree } from 'vuex';
import ILocalState from './stateInterface';
import Jsona from 'jsona';
import { ProductReport } from '@/interfaces/ProductReport';
import { Country } from '@/interfaces/Country';
import { CheckoutEntry } from '@/interfaces/CheckoutEntry';
import { LoginRecord } from '@/interfaces/LoginRecord';
import { BillingAddress } from '@/interfaces/BillingAddress';
import { InvoiceReport } from '@/interfaces/InvoiceReport';
import { StatisticalAnalysisInterface } from '@/interfaces/StatisticalAnalysisInterface';

const dataFormatter = new Jsona();

const getters: GetterTree<ILocalState, {}> = {
    shoppingCartRecords(state) {
        if (!state.shoppingCartRecords) {
            return [];
        }
        return dataFormatter.deserialize(
            state.shoppingCartRecords,
        ) as ProductReport[];
    },
    userData(state) {
        if (!state.userData) {
            return null;
        }
        return dataFormatter.deserialize(state.userData);
    },
    checkoutList(state) {
        if (!state.checkoutList) {
            return [];
        }
        const filter = dataFormatter
            .deserialize(state.checkoutList)
            .filter((listItem: { isActive: string }) => {
                return listItem.isActive;
            });
        return filter as CheckoutEntry[];
    },
    projectBillingsSubscription(state) {
        if (!state.projectBillingsSubscription) {
            return [];
        }
        return dataFormatter.deserialize(
            state.projectBillingsSubscription,
        ) as CheckoutEntry[];
    },
    projectBillingsCredits(state) {
        if (!state.projectBillingsCredits) {
            return [];
        }
        return dataFormatter.deserialize(
            state.projectBillingsCredits,
        ) as CheckoutEntry[];
    },
    activeAccount(state) {
        return state.activeAccount;
    },
    billingAddresses(state) {
        if (!state.billingAddresses) {
            return [];
        }
        return dataFormatter.deserialize(
            state.billingAddresses,
        ) as BillingAddress[];
    },
    bluesnapToken(state) {
        if (!state.bluesnapToken) {
            return null;
        }
        return dataFormatter.deserialize(
            state.bluesnapToken,
        ) as {};
    },
    projectBillings(state) {
        if (!state.projectBillings) {
            return [];
        }
        return dataFormatter.deserialize(
            state.projectBillings,
        ) as CheckoutEntry[];
    },
    invoices(state) {
        if (!state.invoices) {
            return [];
        }
        return dataFormatter.deserialize(state.invoices) as InvoiceReport[];
    },
    loginRecords(state) {
        if (!state.loginRecords) {
            return [];
        }
        return dataFormatter.deserialize(state.loginRecords) as LoginRecord[];
    },
    userColor(state) {
        return state.userColor;
    },
    isUserAuthorized(state) {
        return state.isUserAuthorized;
    },
    currentReportDetails(state) {
        return state.currentReportDetails;
    },
    currentStatisticalAnalysis(state) {
        if (!state.currentStatisticalAnalysis) {
            return null;
        }
        const data = dataFormatter.deserialize(
            state.currentStatisticalAnalysis,
        );
        // @ts-ignore
        Object.assign(data, { meta: state.currentStatisticalAnalysis.meta });
        return data as StatisticalAnalysisInterface[];
    },
    activeProductGroup(state) {
        return state.activeProductGroup;
    },
    token(state) {
        return state.token;
    },
    shoppingListRecords(state) {
        if (!state.shoppingListRecords) {
            return [];
        }
        return dataFormatter.deserialize(
            state.shoppingListRecords,
        ) as ProductReport[];
    },
    filteredShoppingListRecords(state) {
        return state.filteredShoppingListRecords;
    },
    countryList(state) {
        if (!state.countryList) {
            return [];
        }
        return dataFormatter.deserialize(state.countryList) as Country;
    },
    activeCheckoutMethod(state) {
        return state.activeCheckoutMethod;
    },
    switchedUserEmail(state) {
        return state.switchedUserEmail;
    },
    cartSummary(state) {
        return state.cartSummary;
    },
    trademarksShopListItems(state) {
        if (!state.trademarksShopListItems) {
            return [];
        }
        return dataFormatter.deserialize(
            state.trademarksShopListItems,
        ) as ProductReport[];
    },
    trademarksShopCartItems(state) {
        if (!state.trademarksShopCartItems) {
            return [];
        }
        return dataFormatter.deserialize(
            state.trademarksShopCartItems,
        ) as ProductReport[];
    },
    customerShopListItems(state) {
        if (!state.customerShopListItems) {
            return [];
        }
        return dataFormatter.deserialize(
            state.customerShopListItems,
        ) as ProductReport[];
    },
    customerShopCartItems(state) {
        if (!state.customerShopCartItems) {
            return [];
        }
        return dataFormatter.deserialize(
            state.customerShopCartItems,
        ) as ProductReport[];
    },
    goodwillShopListItems(state) {
        if (!state.goodwillShopListItems) {
            return [];
        }
        return dataFormatter.deserialize(
            state.goodwillShopListItems,
        ) as ProductReport[];
    },
    goodwillShopCartItems(state) {
        if (!state.goodwillShopCartItems) {
            return [];
        }
        return dataFormatter.deserialize(
            state.goodwillShopCartItems,
        ) as ProductReport[];
    },
    technologyShopListItems(state) {
        if (!state.technologyShopListItems) {
            return [];
        }
        return dataFormatter.deserialize(
            state.technologyShopListItems,
        ) as ProductReport[];
    },
    technologyShopCartItems(state) {
        if (!state.technologyShopCartItems) {
            return [];
        }
        return dataFormatter.deserialize(
            state.technologyShopCartItems,
        ) as ProductReport[];
    },
    softwareShopListItems(state) {
        if (!state.softwareShopListItems) {
            return [];
        }
        return dataFormatter.deserialize(
            state.softwareShopListItems,
        ) as ProductReport[];
    },
    softwareShopCartItems(state) {
        if (!state.softwareShopCartItems) {
            return [];
        }
        return dataFormatter.deserialize(
            state.softwareShopCartItems,
        ) as ProductReport[];
    },
};

export default getters;
